import { ShippingMethodUid } from "@/services/marketplace/shippingMethod/shippingMethodSchema";
import { type ShippingMethod } from "@/services/marketplace/shippingMethod/shippingMethodTypes";

export function isZasilkovna(methodUid: ShippingMethodUid): boolean {
  return (
    methodUid === ShippingMethodUid.ZasilkovnaAddressDelivery || //
    isZasilkovnaPickupPoint(methodUid)
  );
}

export function isZasilkovnaPickupPoint(methodUid: ShippingMethodUid): boolean {
  return methodUid === ShippingMethodUid.ZasilkovnaPickupPoint;
}

export function hasZasilkovnaWidget(shippingMethod: ShippingMethod): boolean {
  return shippingMethod.uid === ShippingMethodUid.ZasilkovnaPickupPoint;
}
